<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <div class="m-quick-sidebar__content">
                <ul
                  id="m_quick_sidebar_tabs"
                  class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
                  role="tablist"
                >
                  <li class="nav-item m-tabs__item">
                    <a
                      class="nav-link m-tabs__link active"
                      data-toggle="tab"
                      href="#save_contract"
                      role="tab"
                    >
                      <h5><span class="fas fa-users-medical"></span> Novo Usuario</h5>
                    </a>
                  </li>
                </ul>
              </div>
              <div
                id="alert"
                class="alert alert-dismissible fade show  m-alert m-alert--outline mb-4 mt-4"
                :class="alert.color"
                role="alert"
                v-if="alert.message"
              >
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="alert.message = ''"
                ></button>
                <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
                ><br />
                {{ alert.reason }}
              </div>
              <form name="newUser" class="needs-validation" novalidate>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-danger': !data.name }">
                      <label for="name"
                        >Name <span v-if="!data.id" class="m--font-danger">*</span></label
                      >
                      <div class="input-group">
                        <input
                          id="name"
                          type="text"
                          class="form-control"
                          placeholder=""
                          ref="name"
                          v-model="data.name"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-danger': !data.email }">
                      <label for="email"
                        >E-mail <span v-if="!data.id" class="m--font-danger">*</span></label
                      >
                      <div class="input-group">
                        <input
                          id="email"
                          type="email"
                          class="form-control"
                          placeholder=""
                          ref="email"
                          v-model="data.email"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-danger': !data.password }">
                      <label for="password"
                        >Senha <span v-if="!data.id" class="m--font-danger">*</span></label
                      >
                      <div class="input-group">
                        <input
                          id="password"
                          type="password"
                          class="form-control"
                          placeholder=""
                          ref="password"
                          v-model="data.password"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-danger': !data.c_password }">
                      <label for="c_password"
                        >Confirma Senha <span v-if="!data.id" class="m--font-danger">*</span></label
                      >
                      <div class="input-group">
                        <input
                          id="c_password"
                          type="password"
                          class="form-control"
                          placeholder=""
                          ref="c_password"
                          v-model="data.c_password"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <hr class="row mt-5 mb-3" />
                <div class="row">
                  <div class="col-md-12 text-right">
                    <p class="p-0 m-0">
                      <a
                        href="#"
                        @click.prevent="$refs.name.focus()"
                        target="_self"
                        class="m--font-danger"
                        v-if="!data.name"
                        >O campo <strong>Name</strong> é obrigatório *</a
                      >
                    </p>
                    <p class="p-0 m-0">
                      <a
                        href="#"
                        @click.prevent="$refs.email.focus()"
                        target="_self"
                        class="m--font-danger"
                        v-if="!data.email"
                        >O campo <strong>Email</strong> é obrigatório *</a
                      >
                    </p>
                    <p class="p-0 m-0">
                      <a
                        href="#"
                        @click.prevent="$refs.password.focus()"
                        target="_self"
                        class="m--font-danger"
                        v-if="!data.password"
                        >O campo <strong>Password</strong> é obrigatório *</a
                      >
                    </p>
                    <p class="p-0 m-0">
                      <a
                        href="#"
                        @click.prevent="$refs.c_password.focus()"
                        target="_self"
                        class="m--font-danger"
                        v-if="!data.c_password"
                        >O campo <strong>Confirm Password</strong> é obrigatório *</a
                      >
                    </p>
                    <p class="p-0 m-0">
                      <a
                        href="#"
                        @click.prevent="$refs.c_password.focus()"
                        target="_self"
                        class="m--font-danger"
                        v-if="data.password !== data.c_password"
                        ><strong>As Senhas</strong> não pode ser diferentes</a
                      >
                    </p>
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-md-12 text-right">
                    <button
                      @click.prevent="saveForm()"
                      class="btn"
                      :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
                      :disabled="!formIsValid"
                    >
                      <i class="fas fa-save" v-if="formIsValid"></i>
                      <i class="fas fa-exclamation-triangle" v-else></i>
                      Criar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';

export default {
  mixins: [returnMessageFormMixin],
  name: 'NewUser',
  components: {},
  data() {
    return {
      data: {},
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    saveForm() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Aguarde, salvando os dados!',
        reason: '',
      };

      const { data } = this;

      const url = `${baseApiUrl}/v1/user/register`;
      axios
        .post(url, data)
        .then((res) => {
          this.alert = {
            color: 'alert-success',
            icon: 'fas fa-check fa-lg',
            message: res.data.message,
            reason: '',
          };
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
  },
  computed: {
    newUserId() {
      return this.$store.state.showNewUserSave;
    },
    formIsValid() {
      if (
        this.data.name &&
        this.data.email &&
        this.data.password &&
        this.data.c_password &&
        this.data.password === this.data.c_password
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
